import { useMutation } from "@apollo/client";
import { TranslateOrderDesignCommentDocument } from "../../gql/generated/graphql";

export const useTranslateOrderDesignComment = () => {
  const [translateComment, { loading }] = useMutation(
    TranslateOrderDesignCommentDocument,
    { refetchQueries: ["GetOrderDesignsByOrderId"] }
  );

  return {
    translateComment: (params: { commentId: string; translation: string }) =>
      translateComment({
        variables: {
          commentId: params.commentId,
          translation: params.translation,
        },
      }),
    isTranslatingComment: loading,
  };
};
